module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_innlandet_neg.6682f773.png";